/* tslint:disable */
/* eslint-disable */
/**
 * CrateHackers API
 * This is the thing that does data stuff.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the UpdateTutorialVideoDto interface.
 */
export function instanceOfUpdateTutorialVideoDto(value) {
    return true;
}
export function UpdateTutorialVideoDtoFromJSON(json) {
    return UpdateTutorialVideoDtoFromJSONTyped(json, false);
}
export function UpdateTutorialVideoDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'videoId': json['videoId'] == null ? undefined : json['videoId'],
        'link': json['link'] == null ? undefined : json['link'],
        'imgAlt': json['imgAlt'] == null ? undefined : json['imgAlt'],
        'displayOrder': json['displayOrder'] == null ? undefined : json['displayOrder'],
        'active': json['active'] == null ? undefined : json['active'],
    };
}
export function UpdateTutorialVideoDtoToJSON(json) {
    return UpdateTutorialVideoDtoToJSONTyped(json, false);
}
export function UpdateTutorialVideoDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'videoId': value['videoId'],
        'link': value['link'],
        'imgAlt': value['imgAlt'],
        'displayOrder': value['displayOrder'],
        'active': value['active'],
    };
}
